module.exports = __webpack_public_path__ + "img/who2.e76a88ee.webp";